// Material UI
import { makeStyles } from '@material-ui/core'
// Const
import Colors from '../../constants/Colors'

export default makeStyles(theme => {
  return {
    advancedFiltersText: {
      color: Colors.PRIMARY_FONT_COLOR,
      display: 'none',
      fontSize: 14,
      fontWeight: 600,
      lineHeight: 1.71,
      margin: 0,
      textAlign: 'center',
      [theme.breakpoints.up('md')]: {
        display: 'initial',
      },
    },
    root: {
      width: '100%',
      minHeight: '3rem',
      margin: '1rem 0',
      padding: '0 1rem',
      display: 'flex',
      gap: '0.5rem',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: Colors.WHITE_SMOKE,
      borderTop: `1px solid ${Colors.DISABLED_COLOR}`,
      [theme.breakpoints.up('md')]: {
        padding: '1rem 2rem',
        margin: 0,
        minHeight: '2rem',
        justifyContent: 'flex-start',
        backgroundColor: Colors.WHITE,
      },
    },
    chip: {
      alignSelf: 'flex-end',
      display: 'grid',
      gridAutoFlow: 'row',
      gridAutoRows: 'max-content',
      padding: '8px 16px 0px 16px',
      [theme.breakpoints.up('md')]: {
        justifySelf: 'center',
        padding: '0px 16px 0px 16px',
      },
    },
    orderSearchTextFieldRoot: {
      width: '100%',
      height: '100%',
      '&> div': {
        height: '100%',
      },
      [theme.breakpoints.up('md')]: {
        width: 'initial',
      },
    },
    input: {
      height: '100%',
      padding: 0,
      fontSize: '0.875rem',
      lineHeight: '1.5rem',
    },
  }
})
